import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useProducts } from '../hooks/useProducts';
import ProductCard from './ProductCard';
import './Productlist.css';

export default function Productlist({ category, featured }) {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('search') || '';

  const { products, loading, error } = useProducts({
    category,
    featured,
    search: searchQuery,
  });

  if (loading) {
    return (
      <div className="home-page">
        <div className="loading-state">Loading products…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="home-page">
        <div className="error-state">⚠️ {error}</div>
      </div>
    );
  }

  return (
    <div className="home-page">
      {searchQuery && (
        <div className="search-results-header">
          <h2>Results for "{searchQuery}"</h2>
          <p>{products.length} product(s) found</p>
        </div>
      )}

      <section className="all-products-section">
        {!searchQuery && (
          <div className="section-header">
            <h2>{featured ? 'Featured Products' : ''}</h2>
          </div>
        )}

        {products.length === 0 ? (
          <div className="no-results">
            <p>
              {searchQuery
                ? `No products found for "${searchQuery}"`
                : 'No products available'}
            </p>
            <Link
              to="/"
              className="atc-btn"
              style={{
                display: 'inline-block',
                width: 'auto',
                padding: '14px 36px',
                textDecoration: 'none',
                color: 'white',
                background: '#000',
                borderRadius: '4px',
              }}
            >
              Browse All Products
            </Link>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}